import axios, { type AxiosInstance } from 'axios'
import { env } from '../lib/env'
import type { ApiSession } from '../lib/browserSession'
import { installSessionInterceptors } from './sessionInterceptors'

let session: ApiSession | undefined
export function attachSession(value: ApiSession): void { session = value }

const baseURL = import.meta.env.DEV ? '/api/v1' : env.VITE_API_BASE
export const api: AxiosInstance = axios.create({ baseURL, timeout: 30000 })
installSessionInterceptors(api, () => session)
